class SliderReviews extends HTMLElement {
  constructor() {
    super();

    this.sliderElement = this.querySelector("[data-slider-main]");
    this.controls = this.querySelectorAll("[data-control]");
    this.paginationContainer = this.querySelector("[data-slider-pagination]");

    this.controls.forEach((control) => {
      control.addEventListener(
        "click",
        this.onControlClick.bind(this)
      );
    });

    if (!this.sliderElement) return;

    const perPage =
      Number(this.sliderElement.dataset.slidesPerPage) || 2;

    const gap =
      this.sliderElement.dataset.gap || "9.6rem";

    const breakpoint =
      Number(this.sliderElement.dataset.breakpoint) || 990;

    this.slider = new Splide(this.sliderElement, {
      type: "loop",
      pagination: Boolean(this.paginationContainer),
      waitForTransition: false,
      arrows: false,
      perPage: perPage,
      gap: gap,
      speed: 800,
      easing: "ease-in-out",

      breakpoints: {
        [breakpoint]: {
          perPage: 1,
        },
      },
    });

    this.slider.mount();

    /* VIDEO POSTERS */
    this.querySelectorAll("[data-review-poster]").forEach((poster) => {
      poster.addEventListener("click", () => {
        const wrapper = poster.closest(
          ".mara-nude-reviews__video-wrapper"
        );

        const video = wrapper?.querySelector("video");

        if (!video) return;

        poster.style.display = "none";

        video.play();
      });
    });

    /*
     * Splide generates pagination inside .splide.
     * For this section we move it between our arrows.
     */
    if (this.paginationContainer) {
      const pagination =
        this.sliderElement.querySelector(".splide__pagination");

      if (pagination) {
        this.paginationContainer.appendChild(pagination);
      }
    }
  }

  onControlClick(event) {
    event.preventDefault();

    if (!this.slider) return;

    const control = event.currentTarget;

    const action = control.hasAttribute("data-prev")
      ? "<"
      : ">";

    this.slider.go(action);
  }
}

if (!customElements.get("slider-reviews")) {
  customElements.define("slider-reviews", SliderReviews);
}